import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-kg-layout',
  templateUrl: './kg-layout.component.html',
})
export class KgLayoutComponent {
  constructor(
    private titleService: Title) {
    this.titleService.setTitle('BusyFly - аренда самокатов и велосипедов в твоем городе');
  }
}
